import { Routes } from '@angular/router';
import { AppLayout, Notfound } from '@spike/scaffolds';
import { EtiquettePageComponent } from '../features/configuration/pages/etiquette-page/etiquette-page';
import { ModelPageComponent } from '../features/configuration/pages/model-page/model-page';
import { canActivateAuthRole } from '@spike/core';
import { PositionsPageComponent } from '../features/orders/pages/positions-page/positions-page';
import { PositionWorkflow, PreventiveWorkflow, ProductionWorkflow, ProjectWorkflow, ShippingWorkflow } from '../features/workflow/models/workflow-status.enum';
import { EquipmentRequestPageComponent } from '../features/orders/pages/equipment-request-page/equipment-request-page';
import { OrdersPageComponent } from '../features/orders/pages/orders-page/orders-page';
import { PrintOperationsComponent } from '../features/orders/components/print-operations/print-operations';
import { OrganizationPageComponent } from '../features/organizations/pages/organization-page/organization-page';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from './entity-api.enum';
import { HomePage } from '../features/shared/pages/home-page/home-page';

export const routeConfig: Routes = [
    // Rotta per la home page
     {path: 'organization', component: AppLayout, canActivate: [canActivateAuthRole], children: [
            { path: 'clients', component: OrganizationPageComponent, data: {
                title: 'Clienti',
                subTitle:'Gestisci e visualizza le anagrafiche dei clienti',
                icon: 'pi pi-address-book',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Clienti', icon:'pi pi-address-book'}],
                entityApi: EntityApiEnum.CLIENT,
                etiquetteApi: EtiquetteApiEnum.CLIENT,
                modelApi: ModelApiEnum.CLIENT,
                entityKey: 'clientId'
                }
            },
            { path: 'employers', component: OrganizationPageComponent, data: {
                title: 'Dipendenti',
                subTitle:'Gestisci e visualizza le anagrafiche dei dipendenti',
                icon: 'pi pi-users',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Dipendenti', icon:'pi pi-id-users'}],
                entityApi: EntityApiEnum.EMPLOYEE,
                etiquetteApi: EtiquetteApiEnum.EMPLOYEE,
                modelApi: ModelApiEnum.EMPLOYEE,
                entityKey: 'employeeId'
                }},
            { path: 'machines', component: OrganizationPageComponent, data: {
                title: 'Macchinari',
                subTitle:'Gestisci e visualizza le anagrafiche dei macchinari',
                icon: 'pi pi-sitemap',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Macchinari', icon:'pi pi-sitemap'}],
                entityApi: EntityApiEnum.MACHINE,
                etiquetteApi: EtiquetteApiEnum.MACHINE,
                modelApi: ModelApiEnum.MACHINE,
                entityKey: 'machineId'
                }},
            { path: 'suppliers', component: OrganizationPageComponent, data: {
                title: 'Fornitori',
                subTitle:'Gestisci e visualizza le anagrafiche dei fornitori',
                icon: 'pi pi-shop',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Fornitori', icon:'pi pi-shop'}],
                entityApi: EntityApiEnum.SUPPLIER,
                etiquetteApi: EtiquetteApiEnum.SUPPLIER,
                modelApi: ModelApiEnum.SUPPLIER,
                entityKey: 'supplierId'
                }},
            { path: 'vehicles', component: OrganizationPageComponent,  data: {
                title: 'Veicoli',
                subTitle:'Gestisci e visualizza le anagrafiche dei veicoli',
                icon: 'pi pi-truck',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Veicoli', icon:'pi pi-truck'}],
                entityApi: EntityApiEnum.VEHICLE,
                etiquetteApi: EtiquetteApiEnum.VEHICLE,
                modelApi: ModelApiEnum.VEHICLE,
                entityKey: 'vehicleId'
                }},
            { path: 'equipments', component: OrganizationPageComponent,  data: {
                title: 'Tipi Materiali',
                subTitle:'Gestisci e visualizza le anagrafiche dei materiai',
                icon: 'pi pi-truck',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Tipi Materiali', icon:'pi pi-truck'}],
                entityApi: EntityApiEnum.EQUIPMENT,
                etiquetteApi: EtiquetteApiEnum.EQUIPMENT,
                modelApi: ModelApiEnum.EQUIPMENT,
                entityKey: 'equipmentId'
                }},
             { path: 'operations', component: OrganizationPageComponent,  data: {
                title: 'Tipi Operazioni',
                subTitle:'Gestisci e visualizza le anagrafiche dei tipi operazioni',
                icon: 'pi pi-hammer',
                breadcrumbItems:[{label:'Organizzazione'}, {label:'Tipi Operazioni', icon:'pi pi-hammer'}],
                entityApi: EntityApiEnum.OPERATION,
                etiquetteApi: EtiquetteApiEnum.OPERATION,
                modelApi: ModelApiEnum.OPERATION,
                entityKey: 'operationId'
                }},
        ]
    },
     {path: 'production', component: AppLayout, canActivate: [canActivateAuthRole], children: [
            { path: 'equipment-requests', component: EquipmentRequestPageComponent, data: {
                title: 'Approvvigionamenti', 
                subTitle:'Gestisci e monitora le richieste materiale',
                icon: 'pi pi-file',
                breadcrumbItems:[{label:'Approvvigionamenti'}]
            }},
            { path: 'orders', component: OrdersPageComponent, data: {
                title: 'Commesse', 
                subTitle:'Gestisci e monitora le commesse',
                icon: 'pi pi-file',
                breadcrumbItems:[{label:'Commesse'}]
            }},
            { path: 'positions', component: PositionsPageComponent, data: {
                workflowState: PositionWorkflow, 
                title: 'Posizioni',
                subTitle:'Gestisci e monitora le posizioni',
                breadcrumbItems:[{label:'Posizioni'}],
            }},
        ]
    },
    {path: 'external/scheda', component: PrintOperationsComponent, canActivate: [canActivateAuthRole]},
    {path: 'workflow', component: AppLayout, canActivate: [canActivateAuthRole], children: [
            { path: 'preventives', component: PositionsPageComponent, data: {
                workflowState: PreventiveWorkflow, 
                title: 'Preventivi',
                subTitle:'Gestisci e monitora i preventivi',
                breadcrumbItems:[{label:'Posizioni'}, {label:'Preventivi'}],
            }},
            { path: 'projects', component: PositionsPageComponent, data: { 
                workflowState: ProjectWorkflow,
                subTitle:'Gestisci e monitora le progettazioni',
                title: 'Progettazioni',
                breadcrumbItems:[{label:'Posizioni'}, {label:'Progettazioni'}]
            }},
            { path: 'productions', component: PositionsPageComponent, data: {
                workflowState: ProductionWorkflow,
                subTitle:'Gestisci e monitora la produzione',
                title: 'Produzioni',
                breadcrumbItems:[{label:'Posizioni'}, {label:'Produzioni'}]
            }},
            { path: 'shippings', component: PositionsPageComponent, data: {
                workflowState: ShippingWorkflow, 
                subTitle:'Gestisci e monitora le spedizioni',
                title: 'Spedizioni',
                breadcrumbItems:[{label:'Posizioni'}, {label:'Spedizioni'}]
            }},
        ]
    },
    {path: 'configuration', component: AppLayout, canActivate: [canActivateAuthRole], children: [
            { path: 'etiquettes', component: EtiquettePageComponent, data: {
                title: 'Etichette', 
                subTitle:'Gestisci le etichette',
                breadcrumbItems:[{label:'Configurazione'}, {label:'Etichette'}],
                icon: 'pi pi-file'
            }},
            { path: 'models', component: ModelPageComponent, data: {
                title: 'Modelli', 
                subTitle:'Gestisci i modelli',
                breadcrumbItems:[{label:'Configurazione'}, {label:'Modelli'}],
                icon: 'pi pi-file'
            }},
            { path: '**', component: Notfound},
        ]
    },
    {path: '', component: AppLayout, children: [
            { path: 'home', component: HomePage},
            { path: '**', component: Notfound},
        ]
    },
  ];


  